import { Divider, Stack, styled, Typography } from '@mui/material';

/**
 * Details row container
 * Groups detail columns horizontally
 * Mobile: Stacks vertically
 */
export const DetailsRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  paddingTop: theme.spacing(4.5),
  [theme.breakpoints.down('md')]: {
    paddingRight: 0,
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}));

/**
 * Details column container
 * Groups related fields vertically
 * Fixed width on desktop, full width on mobile
 */
export const DetailsColumn = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  flex: 1,
  minWidth: 0,
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

/**
 * Detail field container
 * Displays label and value vertically
 */
export const DetailField = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(1.25, 0),
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2.5, 0),
  },
}));

/**
 * Detail field label with question icon
 */
export const DetailFieldLabel = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(0.5),
  alignItems: 'center',
}));

/**
 * Detail field value
 */
export const DetailFieldValue = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  fontSize: theme.typography.pxToRem(14),
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.text.primary,
  textAlign: 'right',
  [theme.breakpoints.down('md')]: {
    ...theme.typography.caption,
    fontSize: theme.typography.pxToRem(12),
  },
}));

/**
 * Timeline container
 * Horizontal layout for steps
 * Mobile: May need adjustments
 */
export const TimelineContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: theme.spacing(2.5),
  paddingLeft: theme.spacing(8.5),
  paddingRight: 0,
  paddingTop: theme.spacing(0),
  paddingBottom: theme.spacing(0),
  [theme.breakpoints.down('md')]: {
    paddingLeft: theme.spacing(4),
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}));

/**
 * Vertical divider between detail columns
 */
export const DetailsDivider = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.divider,
  alignSelf: 'stretch',
  width: 0,
  marginRight: theme.spacing(6),
  marginLeft: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));
